export default __webpack_public_path__ + "static/bg-1-48c1927f74cacddb99607210d992a74d.png";